import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';
import { FileUploadTooltip } from '../FileUploadTooltip';

const desktopOnly = css`
  @media (max-width: 480px) {
    display: none;
  }
`;

const mobileOnly = css`
  @media (max-width: 480px) {
    display: initial;
  }
  display: none;
`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const DragDropTarget = styled.label`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 4px;
  margin: 0px;
  width: 100%;
  padding: 20px 10px;
  text-align: center;
  min-height: 111px;
  max-height: 160px;
  > input {
    display: none;
  }
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  &:hover {
    cursor: pointer;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding: 0;
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    max-height: 260px;
  }
`;

export const DragAreaEmptyState = styled.div`
  margin: 10px 20px;

  ${desktopOnly}
`;

export const DragDropText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  user-select: none;
  font-weight: 600;
`;

export const BrowseText = styled.span`
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
`;

export const LimitText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  margin: 0;
  margin-top: 10px;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  text-rendering: optimizelegibility;
  user-select: none;
`;

export const LowerSectionContainer = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const SupportedFilesContainer = styled.div`
  width: 100%;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const FileList = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow-y: auto;
  gap: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const UploadButtonContainer = styled.div`
  margin-top: 15px;
  width: 100%;

  ${mobileOnly}
`;

export const SupportFilesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FileSizeText = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  padding: 20px 0;
`;

export const InputContainer = styled.div`
  display: none;
`;

export const DesktopFileTooltip = styled(FileUploadTooltip)`
  ${desktopOnly}
`;

export const FileUploadErrorText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.destructive.default};
  margin: 20px 0;
`;

export const ErrorTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 320px;
  margin-bottom: 20px;
  padding: 20px 0;
`;

export const StyledText = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  padding-top: 20px;
  margin-top: 0;
  text-align: center;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;
